export default __webpack_public_path__ + "images/15b11b74200f46ce6ee92dd5805dd50e-do_8.png";